// @flow

import React, { type Node, useCallback, useState, useMemo } from 'react';

import { HighlightBox, Select, SelectOption, Padding, Label } from '../../../../../../commons/atoms';
import { Field, List, ListItem } from '../../../../../../commons/molecules';

type Props = {|
  +label: string,
  +options: { [string]: string[] },
|};

export function InformationAccordionBody({ label, options }: Props): Node {
  const providers = useMemo(() => Object.keys(options), [options]);

  const [selectedProvider, setSelectedProvider] = useState<string>(providers[0]);

  const handleSelectedProviderChange = useCallback(event => setSelectedProvider(event.target.value), [
    setSelectedProvider,
  ]);

  return (
    <HighlightBox bordered>
      <Padding value="1em">
        <Field label={<Label>{label}</Label>}>
          <Select onChange={handleSelectedProviderChange} value={selectedProvider}>
            {providers.map(element => (
              <SelectOption key={element} value={element}>
                {element}
              </SelectOption>
            ))}
          </Select>
        </Field>
        <List>
          {options[selectedProvider].map((message, index) => (
            <ListItem key={index}>{message}</ListItem>
          ))}
        </List>
      </Padding>
    </HighlightBox>
  );
}
